import { Injectable } from '@angular/core';
import { State, Action, StateContext, Selector } from '@ngxs/store';
import { catchError, tap } from 'rxjs';

import { OnderwijslocatiesStateModel, onderwijslocatieInitialState } from '@store/models/onderwijslocaties.model';
import { OnderwijslocatiesActions } from '@store/actions/onderwijslocaties.actions';
import { OnderwijsLocatie } from '@models/onderwijs-locatie.model';
import { ApiClientService } from '@services/api-client.service';

@State<OnderwijslocatiesStateModel>({
  name: 'onderwijslocaties',
  defaults: onderwijslocatieInitialState,
})
@Injectable()
export class OnderwijslocatiesState {
  constructor(private readonly apiClientService: ApiClientService) {}

  @Selector()
  static onderwijslocaties(state: OnderwijslocatiesStateModel): OnderwijsLocatie[] | null {
    return state.onderwijslocaties;
  }

  @Action(OnderwijslocatiesActions.LoadOnderwijslocaties)
  loadOnderwijslocaties(ctx: StateContext<OnderwijslocatiesStateModel>) {
    const state = ctx.getState();
    ctx.patchState({ ...state, loading: true, loaded: false, error: null });

    return this.apiClientService.getOnderwijslocaties().pipe(
      tap((onderwijslocaties) => {
        onderwijslocaties = this.setDisplayNaam(onderwijslocaties);
        ctx.patchState({ onderwijslocaties, loading: false, loaded: true });
      }),
      catchError((error) => {
        ctx.patchState({ loading: false, error: error.message });
        throw error;
      }),
    );
  }

  @Action(OnderwijslocatiesActions.SelectOnderwijslocatie)
  selectedOnderwijslocatie(
    ctx: StateContext<OnderwijslocatiesStateModel>,
    action: OnderwijslocatiesActions.SelectOnderwijslocatie,
  ) {
    ctx.patchState({ selectOnderwijslocatie: action.payload });
  }

  setDisplayNaam(onderwijslocaties: OnderwijsLocatie[]): OnderwijsLocatie[] {
    return onderwijslocaties.map((locatie) => ({
      ...locatie,
      displayNaam: `${locatie.naam} (${locatie.straat} ${locatie.huisNummer})`,
    }));
  }
}
